<mat-progress-bar [hidden]="!isLoading" color="primary" mode="indeterminate"></mat-progress-bar>
<mat-card-content class="no-padding" *ngIf="filters">
  <div [hidden]="isLoading || (!dataSource || dataSource.length == 0)">
    <div>
      <table class="scroll-table" mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="nrt">
          <th mat-header-cell *matHeaderCellDef> nrt </th>
          <td mat-cell *matCellDef="let element"> {{ element?.nrt }} </td>
        </ng-container>

        <ng-container matColumnDef="documento">
          <th mat-header-cell *matHeaderCellDef> Documento </th>
          <td mat-cell *matCellDef="let element"> {{ element?.documento }} </td>
        </ng-container>

        <ng-container matColumnDef="volumetria">
          <th mat-header-cell *matHeaderCellDef> Volumetria </th>
          <td mat-cell *matCellDef="let element"> {{ element?.volumetria }} </td>
        </ng-container>

        <ng-container matColumnDef="cliente">
          <th mat-header-cell *matHeaderCellDef> Cliente </th>
          <td mat-cell *matCellDef="let element"> {{ element?.cliente }} </td>
        </ng-container>

        <ng-container matColumnDef="produto">
          <th mat-header-cell *matHeaderCellDef> Produto </th>
          <td mat-cell *matCellDef="let element"> {{ element?.produto }} </td>
        </ng-container>

        <ng-container matColumnDef="filial">
          <th mat-header-cell *matHeaderCellDef> Filial </th>
          <td mat-cell *matCellDef="let element"> {{ element?.filial }} </td>
        </ng-container>

        <ng-container matColumnDef="ufDestino">
          <th mat-header-cell *matHeaderCellDef> UF Destino </th>
          <td mat-cell *matCellDef="let element"> {{ element?.ufDestino }} </td>
        </ng-container>

        <ng-container matColumnDef="dtEntrada">
          <th mat-header-cell *matHeaderCellDef> Data de Entrada </th>
          <td mat-cell *matCellDef="let element"> {{ element?.dtEntrada | date: 'dd/MM/yyyy HH:mm' }} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <app-paginacao
      [pageIndex]="filters.paging?.index"
      [pageSize]="filters.paging?.size"
      [length]="filters.paging?.length"
      (page)="onPageChange($event)"
      [pageSizeOptions]="[10, 20, 50]">

    </app-paginacao>
    <div class="d-flex flex-column justify-content-end align-items-end pr-2 pt-2">
      <button mat-flat-button type="button" color="success" (click)="downloadExcel()"
        [disabled]="isLoadingDownload || disableExcel">
        <span *ngIf="isLoadingDownload" class="d-flex align-items-center">
          <mat-spinner diameter="20" color="dark"></mat-spinner>
          &nbsp; Baixando
        </span>
        <span *ngIf="!isLoadingDownload">
          <i class="fas fa-file-excel"></i> Download Excel
        </span>
        <small *ngIf="disableExcel">Quantidade de registros ultrapassa o limite de 1.000.000 para download do
          excel
        </small>
      </button>
    </div>
  </div>
  <div *ngIf="!isLoading && dataSource && dataSource.length == 0"
    class="d-flex justify-content-center align-items-center" style="height: 100px;">
    Nenhum registro para os filtros informados!
  </div>
</mat-card-content>